import { MessageCircle, Instagram } from "lucide-react";
import { useSiteContent } from "@/lib/useSiteContent";

export default function Footer() {
  const c = useSiteContent().footer;
  const nav = useSiteContent().navbar;
  return (
    <footer data-testid="site-footer" className="bg-[#1D1D1F] text-white/70 pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="font-serif-luxe text-3xl text-white">
              {nav.brand_prefix} <span className="text-[#B68D40]">{nav.brand_suffix}</span>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-white/60">
              {c.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[0.7rem] tracking-[0.18em] uppercase text-[#B68D40] mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#who-we-are" className="link-gold">Who We Are</a></li>
              <li><a href="#opportunities" className="link-gold">Opportunities</a></li>
              <li><a href="#trending" className="link-gold">Trending</a></li>
              <li><a href="#philosophy" className="link-gold">Philosophy</a></li>
              <li><a href="#insights" className="link-gold">Market Insights</a></li>
              <li><a href="#contact" className="link-gold">Consultation</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[0.7rem] tracking-[0.18em] uppercase text-[#B68D40] mb-4">Connect</div>
            <ul className="space-y-3 text-sm">
              {c.whatsapp_url && (
                <li>
                  <a href={c.whatsapp_url} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="link-gold inline-flex items-center gap-3">
                    <MessageCircle size={16} strokeWidth={1.3} /> {c.whatsapp_label}
                  </a>
                </li>
              )}
              {c.instagram_url && (
                <li>
                  <a href={c.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="link-gold inline-flex items-center gap-3">
                    <Instagram size={16} strokeWidth={1.3} /> {c.instagram_label}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} {c.copyright}</div>
          <div className="flex gap-6">
            <a href="/privacy-policy" className="link-gold">Privacy Policy</a>
            <a href="/privacy-policy" className="link-gold">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
